//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../Components/Toolkit/Dialog';
import {Calendar} from 'primereact/calendar';
import {CalendarChangeParams} from 'primereact/calendar';

//endregion

/** */
type Props = {
    onDateSelected: (data: Date) => void;
}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    selectedDate: Date;
}

/** */
class CalendarDialog extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.onDateChange = this.onDateChange.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            selectedDate: new Date()
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(initialDate: Date, position?: DialogPositionType) {
        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
            draft.selectedDate = initialDate;
        });
    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private getDialogTemplate(): ReactNode {
        return (
            <Calendar id={'calendar'}
                      disabled={false}
                      onChange={this.onDateChange}
                      inline
            />
        );
    }

    private onDateChange(newValue: CalendarChangeParams) {
        const newDate = Array.isArray(newValue.value)
                        ? newValue.value[0]
                        : typeof newValue.value === 'string'
                          ? new Date(newValue.value)
                          : newValue.value!;

        this.props.onDateSelected(newDate);
        this.hide();
    }

    /** */
    public render(): ReactElement {

        return (
            <React.Fragment>
                <Dialog title={''}
                        content={this.getDialogTemplate()}
                        position={this.state.position}
                        canClose={false}
                        closeOnEscape={false}
                        visible={this.state.visible}
                        onHide={this.dialog_onHide}
                        centreContent={true}
                />
            </React.Fragment>

        );

    }

}

export default CalendarDialog;
